/*
 * @Author: 张斌
 * @Date: 2022-05-05 16:08:19
 * @LastEditors: 张斌
 * @LastEditTime: 2026-01-23 10:30:30
 */
import { commonRequest } from '@/utils/request'
/** 获取用户列表 */
export function getUserList(data: {
  pageNum: number
  pageSize: number
  arg1: string
  userName:string

}) {
  return commonRequest({
    method: 'POST',
    url: '/V1/Admin/User/FindPage',
    data,
  })
}
/** 添加用户 */
export function addUser(data: {
  name: string
  pwd: string
  nickName: string
  role: string
  phone: string
  orgId: string
  posIdList: string[]
}) {
  return commonRequest({
    method: 'POST',
    url: '/V1/Admin/User/Add',
    data,
  })
}
/** 删除用户 */
export function deleteUser(params: {
  name: string
}) {
  return commonRequest({
    method: 'DELETE',
    url: '/V1/User',
    params,
  })
}
/** 修改用户 */
export function modifyUser(data: {
  name: string
  pwd: string
  nickName: string
  phone: string
  role: string
  posIdList: string[]
  orgId: string
}) {
  return commonRequest({
    method: 'POST',
    url: '/V1/Admin/User/UpdatePwd',
    data,
  })
}

// 获取空调每月运行时间
export function getAirMonthWorkTime(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'GET',
    url: '/V1/Org/getAirMonthWorkTime',
    params,
  })
}

// 获取空调模板
export function getAirOrgTemplates() {
  return commonRequest({
    method: 'GET',
    url: '/V1/Org/getAirTemplates',
  })
}

// 获取项目空调运行模板
export function getTemplateIdByOrg(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'GET',
    url: '/V1/Org/getTemplateIdByOrg',
    params,
  })
}

// 获取项目空调运行模板
export function getAirTemplateById(params: {
  templateId: string
}) {
  return commonRequest({
    method: 'GET',
    url: '/V1/Org/getAirTemplateById',
    params,
  })
}

// 更新模板
export function updateAirOrgTemplateMonths(data: {
airTemplateMonthVO:any
}) {
  return commonRequest({
    method: 'POST',
    url: '/V1/Org/updateAirTemplateMonths',
    data,
  })
}

export function getOrgAirCustom(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'GET',
    url: '/V1/Org/getOrgAirCustom',
    params,
  })
}

export function getFilterHolidayWeekend(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'GET',
    url: '/V1/Org/getFilterHolidayWeekend',
    params,
  })
}

export function upDatefilterHolidyWeekend(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'POST',
    url: '/V1/Org/upDatefilterHolidyWeekend',
    params,
  })
}



// 更新项目运行时间
export function updateAirOrgDayTime(data: {
  orgAirMonthDayAddVO:any
}) {
  return commonRequest({
    method: 'POST',
    url: '/V1/Org/updateOrgAirMonthDayTime',
    data,
  })
}



// 更新项目模板
export function updateTemplateOrg(data: {
  orgId : string
  templateId : string
}) {
  return commonRequest({
    method: 'POST',
    url: '/V1/Org/updateTemplateOrg?orgId='+data.orgId+'&templateId='+data.templateId,
    
  })
}

// 添加模板
export function addAirMonthTemplate(data: {
  airTemplateAddVO:any
  }) {
    return commonRequest({
      method: 'POST',
      url: '/V1/Org/addAirMonthTemplate',
      data,
    })
  }

  // 添加模板月份设置
export function addAirTemplateMonths(data: {
  airTemplateMonthVO:any
  }) {
    return commonRequest({
      method: 'POST',
      url: '/V1/Org/addAirTemplateMonths',
      data,
    })
  }
    // 添加模板月份设置
export function addAirOrgDayTime(data: {
  orgAirMonthDayAddVO:any
  }) {
    return commonRequest({
      method: 'POST',
      url: '/V1/Org/addOrgAirMonthDayTime',
      data,
    })
  }

  // 更新项目模板
export function addTemplateOrg(data: {
  orgId : string
  templateId : string
}) {
  return commonRequest({
    method: 'POST',
    url: '/V1/Org/addTemplateOrg?orgId='+data.orgId+'&templateId='+data.templateId,
    
  })
}

/** 删除用户绑定模板 */
export function deleteTemplateOrg(params: {
  orgId : string
}) {
  return commonRequest({
    method: 'DELETE',
    url: '/V1/Org/deleteTemplateOrg',
    params,
  })
}


/** 导出空开*/

export function exportElectric(data) {
  return commonRequest({
    method: 'POST',
    url: '/V1/Electric/export',
    responseType: 'blob',
    headers:{
      'Content-Type':'application/json;charset=UTF-8',
    },
    data,
  })
}

/** 导出空开*/

export function exportdevExcel(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'GET',
    url: '/V1/Org/devExcel',
    responseType: 'blob',
   
    params,
 
  })
}

/** 调光亮度及开关*/
// curl --location 'localhost:8092/V1/Admin/Data/NetAdjustSwitch?netId=c4096630-507f-4ca5-bcf8-1c87558ee3dc&date=2024-02-18'
export function netAdjustSwitch(params: {
  netId: string
  date: string
}) {
  return commonRequest({
    method: 'GET',
    url: '/V1/Admin/Data/NetAdjustSwitch',
    params,
  })
}

// 添加模板
export function OrgDeptAdmin(data: {
  qrCodeId:any,
  userList:any[]
  }) {
    return commonRequest({
      method: 'POST',
      url: '/V1/Admin/Data/OrgDeptAdmin',
      data,
    })
  }
// 添加模板
export function screenConfigUpload(data: {
  backgroundFile:any,
  cornerFile:any[],
  metadata:any
  }) {
    return commonRequest({
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
        credentials: 'same-origin'
      },
      url: '/V1/Dev/screenConfig/upload',
      data,
    })
  }
  
  // /V1/Dev/screenConfig/{orgId}
  export function screenConfig(params: {
    orgId: string
  }) {
    return commonRequest({
      method: 'GET',
      url: `/V1/Dev/screenConfig/${params.orgId}`,
      params,
    })
  }

  // 设备元素配置相关接口
  
  /** 新增或更新元素配置 */
  export function setElementConfig(data: {
    orgId: string
    scopeType: 'ORG' | 'ORG_TYPE' | 'NET_TYPE' | 'DEV'
    netId?: string
    devId?: string
    prodTypeCode?: string
    elementKey: string
    elementValue: string
  }) {
    return commonRequest({
      method: 'POST',
      url: '/V3/NetBleMesh/DevElement/setElementConfig',
      data,
    })
  }

  /** 删除元素配置 */
  export function deleteElementConfig(data: {
    orgId: string
    scopeType: 'ORG' | 'ORG_TYPE' | 'NET_TYPE' | 'DEV'
    netId?: string
    devId?: string
    prodTypeCode?: string
    elementKey: string
  }) {
    return commonRequest({
      method: 'POST',
      url: '/V3/NetBleMesh/DevElement/deleteElementConfig',
      data,
    })
  }

  /** 查询设备生效元素配置 */
  export function getElementConfigByDevice(data: {
    devId: string
    elementKey: string
  }) {
    return commonRequest({
      method: 'POST',
      url: '/V3/NetBleMesh/DevElement/getElementConfigByDevice',
      data,
    })
  }

  /** 分页查询元素配置列表 */
  export function listElementConfigs(data: {
    orgId: string
    scopeType?: 'ORG' | 'ORG_TYPE' | 'NET_TYPE' | 'DEV'
    netId?: string
    devId?: string
    prodTypeCode?: string
    elementKey?: string
    pageNo?: number
    pageSize?: number
  }) {
    return commonRequest({
      method: 'POST',
      url: '/V3/NetBleMesh/DevElement/listElementConfigs',
      data,
    })
  }